module.exports = __webpack_public_path__ + "static/media/kick-bass.ba702fe1.mp3";